import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageCircle, Heart } from 'lucide-react';
import { contactInfo } from '../data/mockData';
import { useLanguage } from '../context/LanguageContext';

const Footer = ({ logoUrl }) => {
  const { t } = useLanguage();

  return (
    <footer
      className="py-10 sm:py-14 relative noise-overlay"
      style={{
        background: 'linear-gradient(180deg, #1e3a8a, #1e40af)',
        borderTop: '1px solid rgba(96, 165, 250, 0.06)',
      }}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col items-center gap-6 sm:gap-8 md:flex-row md:justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3 sm:gap-4">
            <img
              src={logoUrl}
              alt="ג'יני מובייל"
              className="w-11 h-11 sm:w-14 sm:h-14 rounded-full object-cover"
              style={{
                border: '1.5px solid rgba(96, 165, 250, 0.3)',
                boxShadow: '0 0 15px rgba(96, 165, 250, 0.08)',
              }}
            />
            <div>
              <div className="font-bold text-white text-base sm:text-lg">{t('footer.businessName')}</div>
              <div className="text-[10px] sm:text-xs font-medium" style={{ color: '#ffffff' }}>Genie Mobile</div>
              <div className="text-[10px] sm:text-xs text-blue-200">{t('footer.ownerInfo')}</div>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex gap-2 sm:gap-3">
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href={contactInfo.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-4 sm:px-6 py-2.5 sm:py-3 rounded-full text-xs sm:text-sm font-bold"
              style={{ background: '#25D366', color: 'white' }}
            >
              <MessageCircle size={14} />
              WhatsApp
            </motion.a>
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="tel:0532222342"
              className="flex items-center gap-2 px-4 sm:px-6 py-2.5 sm:py-3 rounded-full text-xs sm:text-sm font-semibold"
              style={{ border: '1px solid rgba(255, 255, 255, 0.15)', color: 'white' }}
            >
              <Phone size={14} />
              {contactInfo.phone}
            </motion.a>
          </div>

          {/* Social */}
          <div className="flex gap-2 sm:gap-3">
            {[
              { name: t('footer.social.tiktok'), url: contactInfo.social.tiktok, bg: 'linear-gradient(135deg, #000000, #333333)' },
              { name: t('footer.social.facebook'), url: contactInfo.social.facebook, bg: 'linear-gradient(135deg, #1877F2, #4267B2)' },
              { name: t('footer.social.instagram'), url: contactInfo.social.instagram, bg: 'linear-gradient(135deg, #E1306C, #C13584, #833AB4)' },
            ].map((s) => (
              <a
                key={s.name}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                className="px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-[10px] sm:text-xs font-bold"
                style={{ 
                  background: s.bg,
                  border: '2px solid rgba(255, 255, 255, 0.2)',
                  color: '#ffffff',
                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
                }}
              >
                {s.name}
              </a>
            ))}
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-8 pt-5 flex flex-col sm:flex-row items-center justify-center gap-3" style={{ borderTop: '1px solid rgba(255, 255, 255, 0.04)' }}>
          <p className="text-blue-200 text-[10px] sm:text-xs">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
